import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'
import ClosureSurveyData from 'sprockets_react/closure_survey/data/registry'
import { EventEmitter } from 'events'

ClosureSurvey.StepSequence.init()

ClosureSurvey.Emitter = ClosureSurvey.Emitter || new EventEmitter()

ClosureSurvey.Modal = React.createClass({

  getInitialState: function() {
    return {
      closureSurvey: ClosureSurveyData.Data,
      currentStep: this.wizard.Steps[0]
    }
  },

  componentWillMount: function() {
    let closureSurveyData = ClosureSurveyData.Data

    closureSurveyData.outcome = this.props.outcome
    closureSurveyData.providerAccountId = this.props.providerAccountId
    closureSurveyData.providerAccountName = this.props.providerAccountName
    closureSurveyData.rating = this.props.rating

    if (this.props.amountPaid !== null && typeof this.props.amountPaid !== 'undefined') {
      ClosureSurvey.StepSequence.removeStepByType(ClosureSurvey.HowMuchDidYouPay)
    }

    ClosureSurvey.Emitter.addListener('closureSurvey:wizard:advanceToStep', (step, eventArgs) => { this.advanceStep(step, eventArgs) })
    ClosureSurvey.Emitter.addListener('closureSurvey:wizard:advanceToNextStep', this.advanceStep)
  },

  componentDidMount: function() {
    let $jobClosureModal = $('#job-closure-modal')
    $jobClosureModal.modal({ backdrop: 'static', keyboard: 'false' })

    function handleModalExit() {
      ClosureSurveyData.Actions.resetData()
      this.setState({currentStep: this.wizard.Steps[0]})
      $jobClosureModal.modal('hide')
      $jobClosureModal.find('.modal-stay').trigger('click')
      return false;
    }

    $jobClosureModal.on('shown.bs.modal', function () {
      $('body')
        .css('overflow','hidden')
        .css('position','fixed')
        .css('width','100%');
    })
    .on('hide.bs.modal', function () {
      $('body')
        .css('overflow','auto')
        .css('position','inherit')
        .css('width','auto');
    })

    $jobClosureModal.bootstrapValidator({ /* */ })
    this.wizard.Validator = $jobClosureModal.data('bootstrapValidator');

    $jobClosureModal
      .find('.modal-exit')
        .on('click', handleModalExit.bind(this))
        .end()
      .find('.modal-stay')
        .on('click', function() {
          $jobClosureModal
            .find('.close-modal-warning')
              .velocity('slideUp')
            .end()
            .find('.close')
              .rmHidden()
          return false;
        })
  },

  componentWillUnmount: function() {
    this.wizard.Emitter.removeEventListener('closureSurvey:wizard:advanceToStep')
    this.wizard.Emitter.removeListener('closureSurvey:wizard:advanceToNextStep', this.advanceStep)
  },

  wizard: ClosureSurvey,
  stepHistory: [ ClosureSurvey.Steps[0] ],

  advanceStep: function(step) {
    const steps = this.wizard.Steps
    if (!step) {
      let currentStepIndex = steps.indexOf(this.state.currentStep)
      step = steps[currentStepIndex + 1]
    }

    this.stepHistory.push(step)
    this.setState({currentStep: step})
  },

  renderStep: function() {
    return (
      <div>
        <this.wizard.Step
          currentStep={this.state.currentStep}
          onStepProgression={this.advanceStep}
          jobId={this.props.jobId}
          possibleBusinesses={this.props.possibleBusinesses}
          activeReasons={this.props.activeReasons}
          trigger={this.props.trigger}
          medium={this.props.medium}
          fromFastFeedback={this.props.fromFastFeedback}
          iosHref={this.props.iosHref}
          amountPaid={this.props.amountPaid}
          reviewGuidelines={this.props.reviewGuidelines}
        />
      </div>
    )
  },

  render: function() {
    var component = <ClosureSurvey.Form stepComponent={this.renderStep()}/>

    return (
      <div id="job_closure" className="modal-dialog modal-component radius-16" role="document">
        <div className="modal-content radius-16">
          { !['ios', 'android'].includes(this.props.medium) &&
            <ClosureSurvey.CloseModalWarning/>
          }
          <ClosureSurvey.ProgressBar steps={this.wizard.Steps} currentStep={this.state.currentStep} />
          <ClosureSurvey.Header medium={this.props.medium}/>
          <div>
            {component}
          </div>
        </div>
      </div>
    )
  }
})
